module.exports = __webpack_public_path__ + "media/styles/images/png/pencil-white-on-white-8768d2893ce21e232c8f92c670d51ae5.png";